var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.640097 8.2132C0.492374 8.06001 0.457802 7.83011 0.553939 7.64025L1.02161 6.71666C2.12845 4.53078 4.37042 3.15302 6.82056 3.15302H7.05049C7.06726 2.78877 7.08891 2.42469 7.11543 2.06087L7.16065 1.44044C7.19743 0.935895 7.76002 0.65385 8.18631 0.926238C9.58475 1.81981 10.8005 2.97121 11.7687 4.31904L12.0728 4.74234C12.198 4.91665 12.198 5.15144 12.0728 5.32576L11.7687 5.74905C10.8005 7.09689 9.58475 8.24828 8.18631 9.14185C7.76002 9.41424 7.19743 9.13219 7.16065 8.62765L7.11543 8.00722C7.08375 7.57274 7.05903 7.13788 7.04127 6.70281C5.60805 6.66143 4.17658 6.95071 2.861 7.5579L1.20954 8.3201C1.01632 8.40928 0.787819 8.36639 0.640097 8.2132ZM2.11893 6.79902L2.44194 6.64994C4.04937 5.90805 5.81305 5.59485 7.56314 5.72926C7.81801 5.74884 8.01707 5.95751 8.02463 6.21302C8.04161 6.78726 8.07099 7.36123 8.11278 7.93452L8.1164 7.98416C9.21204 7.20972 10.1722 6.25746 10.9565 5.16563L11.051 5.03405L10.9565 4.90246C10.1722 3.81063 9.21204 2.85837 8.1164 2.08393L8.11278 2.13357C8.07548 2.64531 8.04806 3.15759 8.03053 3.67012C8.02131 3.93945 7.80031 4.15302 7.53082 4.15302L6.82056 4.15302C4.88902 4.15302 3.11037 5.16496 2.11893 6.79902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhiteIcon);
export default __webpack_public_path__ + "static/media/shareWhiteIcon.c4b4c781a429b110ef6de8cb6514dfef.svg";
export { ForwardRef as ReactComponent };